<template>
  <div class="success-banner content-page-banner">
    <div class="success-banner-content">
      <slot name="header">
        <h1>{{ header }}</h1>
      </slot>
      <div class="underline" />
      <div class="sub-title-content">
        <slot></slot>
      </div>
    </div>
    <div class="pulsing-circle animate">
      <img src="/assets/public/images/icon_tick.svg" alt="tick icon" />
    </div>
    <div class="success-background" />
  </div>
</template>

<script>
export default {
  name: 'SuccessBanner',
  props: {
    header: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.success-banner {
  @include flex-row;
  justify-content: space-between;
  box-sizing: border-box;
  background-color: $WHITE;
  position: relative;
  min-height: 320px;
  margin-bottom: 3rem;

  @include mobile {
    @include grid-layout;
    @include grid-template(1fr 2fr);

    * {
      box-sizing: border-box;
    }
  }

  &-content {
    max-width: rem(680);
    width: 45%;
    --width: 45%;
    z-index: 2;

    h1 {
      margin: 0;
    }

    @include mobile {
      @include grid-position(1, 2);
      width: 100%;
      padding: 3rem 1rem;
      box-shadow: 0px 2px 6px 0px rgba($GREY_900, 0.06), 0px 2px 4px 0px rgba($GREY_900, 0.02);
    }

    .sub-title-content {
      @include tablet {
        max-width: 450px;
      }
    }
  }
}

.success-background {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  right: calc(50% - 50vw);
  height: 100%;
  top: 0;
  width: 100vw;
  background: linear-gradient(305deg, $PRIMARY_GREEN_TINT 43%, transparent 43%);
  z-index: 1;
  box-shadow: 0px 2px 6px 0px rgba($GREY_900, 0.06), 0px 2px 4px 0px rgba($GREY_900, 0.02);

  @include widescreen {
    width: 100vw;
  }

  @include mobile {
    @include grid-position(1, 1);
    position: relative;
    background: $PRIMARY_GREEN_TINT;
    justify-content: center;
    width: 100%;
    height: rem(140);
    padding: 1.5rem 0.5rem;
    left: 0;
  }
}

.pulsing-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1 / 1;
  width: rem(240);
  z-index: 2;

  @include mobile {
    @include grid-position(1, 1);
    aspect-ratio: unset;
    max-width: unset;
    width: 100%;
    /*DE2E-12255 Remove it as it has no impact but causes issues in iOS 17*/
    /*height: 100%;*/
  }

  img {
    aspect-ratio: 1 / 1;
    box-sizing: border-box;
    background-color: $PRIMARY_MEDIUM_GREEN_60;
    border-radius: 50%;
    padding: 0.5rem;
    width: 80%;
    z-index: 2;

    @include mobile {
      width: rem(60);
    }
  }

  $SMALLER_CIRCLE_RADIUS: rem(220);
  $LARGER_CIRCLE_RADIUS: rem(240);

  &.animate {
    @keyframes pulse {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.2);
      }
      100% {
        transform: scale(1);
      }
    }

    img {
      animation: pulse 2s ease-in-out;
    }
  }
}

.content-page-banner::before {
  background-color: $WHITE;
  box-shadow: 0px 2px 6px 0px rgba($GREY_900, 0.06), 0px 2px 4px 0px rgba($GREY_900, 0.02);

  @include mobile {
    display: none;
  }
}
</style>
